import { DEPARTMENTS } from "@/constants/workflow";

export const VARIES = "Varies";

const MERGED_KEYS = [
  "project_code",
  "elevation",
  "level",
  "type_code",
  "panel_code",
  "panel_type",
  "unique_code",
  "block_definition",
  "source_object_id",
  "shipment_code",
  "shipping_method",
  "pallet_id",
  "pallet_code",
  "estimated_arrival",
  "delivered_on",
  "installed_on",
  "shipped_at",
  "shipped_on",
];

/**
 * Builds a pseudo panel for a multi-selection: shared values are kept,
 * anything that differs between panels becomes "Varies".
 */
export function mergeSelectedPanels(list) {
  if (!list?.length) return null;
  const shared = (key, read) => {
    const first = read(list[0]) ?? null;
    return list.every((panel) => (read(panel) ?? null) === first) ? first : VARIES;
  };
  const merged = {
    multi: true,
    selected_count: list.length,
    panel_uid: null,
    panel_name: null,
    statuses: {},
    workflow_blocked: list.some((panel) => panel.workflow_blocked),
  };
  MERGED_KEYS.forEach((key) => {
    merged[key] = shared(key, (panel) => panel[key]);
  });
  DEPARTMENTS.forEach(({ key }) => {
    merged.statuses[key] = shared(key, (panel) => panel.statuses?.[key]);
  });
  return merged;
}
